import React, { useContext, useEffect, useCallback, useMemo } from 'react';
import { Context } from '../../store'
import './player.css';
import play_btn_img from '../../images/play-button.svg';
import pause_btn_img from '../../images/pause-button.svg';
import zaglushkaLogo from '../../images/zaglushka_logo.png';
import { getAlbumArt } from '../../services/albumArtService';
import DonateForm from './donate_form';

const PlayerWrapper = (_props) => {
  const [state, dispatch] = useContext(Context);

  const trackInfo = state.trackInfo ? state.trackInfo[state.stream] : null;
  const artist = trackInfo?.artist || 'Radio Myata';
  const track = trackInfo?.track || 'RADIO MYATA';
  const albumArts = useMemo(() => state.albumArts || {}, [state.albumArts]);

  // Update Media Session API for Lock Screen / Control Center
  const updateMediaSession = useCallback((artist, track, artworkUrl) => {
    if ('mediaSession' in navigator) {
      try {
        const defaultArt = window.location.origin + zaglushkaLogo;
        const finalArt = artworkUrl || defaultArt;

        const artwork = [
          { src: finalArt, sizes: '96x96', type: artworkUrl ? 'image/jpeg' : 'image/png' },
          { src: finalArt, sizes: '128x128', type: artworkUrl ? 'image/jpeg' : 'image/png' },
          { src: finalArt, sizes: '256x256', type: artworkUrl ? 'image/jpeg' : 'image/png' },
          { src: finalArt, sizes: '512x512', type: artworkUrl ? 'image/jpeg' : 'image/png' },
        ];

        navigator.mediaSession.metadata = new MediaMetadata({
          title: track && track !== 'Загрузка...' ? track : 'Radio Myata',
          artist: artist && artist !== 'Radio Myata' ? artist : 'Radio Myata',
          album: 'Radio Myata',
          artwork: artwork
        });

        // Set action handlers
        navigator.mediaSession.setActionHandler('play', () => {
          const audio = state.audio;
          if (!state.nowPlaying) {
            audio.src = 'https://radio.dline-media.com/' + state.stream;
            audio.load();
            audio.play();
            dispatch({ nowPlaying: true });
          }
        });
        navigator.mediaSession.setActionHandler('pause', () => {
          const audio = state.audio;
          audio.pause();
          audio.src = '';
          dispatch({ nowPlaying: false });
        });
        navigator.mediaSession.setActionHandler('stop', () => {
          const audio = state.audio;
          audio.pause();
          audio.src = '';
          dispatch({ nowPlaying: false });
        });

        console.log('[MediaSession Desktop] Updated:', artist, '-', track);
      } catch (error) {
        console.warn('[MediaSession Desktop] Error:', error);
      }
    }
  }, [state.audio, state.stream, state.nowPlaying, dispatch]);

  // Fetch album art when track changes
  useEffect(() => {
    const fetchArt = async () => {
      const currentInfo = state.trackInfo?.[state.stream];
      if (!currentInfo) return;

      const artistName = currentInfo.artist;
      const trackName = currentInfo.track;

      if (artistName && trackName && artistName !== 'Radio Myata' && artistName !== 'YOUR MUSIC! YOUR STATION!') {
        const cachedArt = albumArts[state.stream];
        if (cachedArt?.artist === artistName && cachedArt?.track === trackName) {
          updateMediaSession(artistName, trackName, cachedArt.url);
          return;
        }

        const art = await getAlbumArt(artistName, trackName);
        dispatch({
          albumArts: {
            ...albumArts,
            [state.stream]: { url: art, artist: artistName, track: trackName }
          }
        });
        updateMediaSession(artistName, trackName, art);
      } else {
        updateMediaSession('Radio Myata', 'Radio Myata', null);
      }
    };

    fetchArt();
  }, [state.trackInfo, state.stream, albumArts, updateMediaSession, dispatch]);

  const playRadio = () => {
    const air = state.audio;
    air.volume = state.volume;
    const streamUrl = 'https://radio.dline-media.com/' + state.stream;

    if (state.nowPlaying) {
      // Currently playing - STOP stream completely
      air.pause();
      air.src = ''; // Clear source to stop loading stream
      air.load(); // Reset the audio element
      dispatch({ nowPlaying: false }); // Explicitly update state since pause event may not fire
    } else {
      // Currently paused - always reload stream from scratch
      air.src = streamUrl;
      air.load();
      air.play().catch(err => {
        console.error('Play error:', err);
      });
    }
  }


  // Sync nowPlaying state with actual audio element state
  React.useEffect(() => {
    const audio = state.audio;

    const handlePlay = () => {
      console.log('Audio play event fired');
      dispatch({ nowPlaying: true });
    };

    const handlePause = () => {
      console.log('Audio pause event fired');
      dispatch({ nowPlaying: false });
    };

    const handleEnded = () => {
      console.log('Audio ended event fired');
      dispatch({ nowPlaying: false });
    };

    audio.addEventListener('play', handlePlay);
    audio.addEventListener('pause', handlePause);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('play', handlePlay);
      audio.removeEventListener('pause', handlePause);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [state.audio, dispatch]);

  // const changeRadioVolume = () => {
  //   const volume_el = document.getElementById('volume-control');
  //   dispatch({ volume: volume_el.value / 100 });
  // }

  return (
    <div className='player-wrapper'>
      <DonateForm />
      <div className='player'>
        <div className='player-control'>
          <img onClick={playRadio} className='play-pause-button' src={state.nowPlaying ? pause_btn_img : play_btn_img} alt='play button' />
        </div>
        <div className='track-info'>
          <span className='track-info-artist'>{artist}</span>
          <span className='track-info-title'>{track}</span>
        </div>
      </div>
    </div>
  )
}

export default PlayerWrapper;
